export enum DocumentState {
    Active = 0,
    Archived = 1,
    WalkInDraft = 2
    }
